import {CheckInterval, CheckStateEventWindow, LatestDowntime, ThirdPartyService} from "@/lib/queries/checks.ts";
import {
  MonitoringServiceType,
  PerformanceDataType,
  ThirdPartyMonitoringType,
  ThirdPartyServiceComponent,
} from "@/lib/types/checks.ts";
import {CheckResponseTimeOverviewProps} from "@/pages/checks/analysis/overview/CheckResponseTimeOverview.tsx";
import {CloudStatusOverview} from "@/pages/checks/analysis/overview/checktypes/CloudStatusOverview.tsx";
import {DefaultCheckOverview} from "@/pages/checks/analysis/overview/checktypes/DefaultCheckOverview.tsx";
import {DaysToExpireOverviewProps} from "@/pages/checks/analysis/overview/DaysToExpireOverview.tsx";
import {Top5AlertsTableProps} from "@/pages/checks/analysis/overview/Top5AlertsTable.tsx";

export interface CheckOverviewProps
  extends Top5AlertsTableProps, Omit<CheckResponseTimeOverviewProps, "intervalAlerts">, DaysToExpireOverviewProps {
  createdAt: Date;
  interval: number;
  checkType: MonitoringServiceType;
  intervals: CheckInterval[];
  cloudStatus?: ThirdPartyServiceComponent;
  thirdPartyGroup?: ThirdPartyService;
  thirdPartyMonitoringType?: ThirdPartyMonitoringType;
  dataType: PerformanceDataType;
  is_paused: boolean;
  cached_state_is_up: boolean;
  latestDowntime?: LatestDowntime;
  outages?: number;
  downtime_secs?: number;
  uptimeBarEvents: CheckStateEventWindow[];
}

export const CheckOverview = (props: CheckOverviewProps) => (
  <>
    {props.checkType === MonitoringServiceType.CLOUDSTATUS && <CloudStatusOverview {...props} />}
    {props.checkType !== MonitoringServiceType.CLOUDSTATUS && <DefaultCheckOverview {...props} />}
  </>
);
